import { connect } from 'react-redux';
import { editDeviation } from '../../../redux/deviations/actionCreators';
const mapDispatchToProps = (dispatch, { deviation })=>({
        editTier: ()=>dispatch(editDeviation({
                deviation
            }))
    });
export default connect(null, mapDispatchToProps);

//# sourceMappingURL=EditTier.container.js.map